export const messages = {
  FAILED: 'נִכשָׁל',
  GRID_ROW_SAVED: 'נשמר',
  GRID_ROW_REMOVED: 'הוסר',
};